// QPU/noise display names, ported from ionq-cloud-ui src/util/qpu.ts and
// src/components/shared/noiseModelsMap.ts.

const TARGET_TRANSLATION: Record<string, string> = {
    simulator: 'Simulator',
    'qpu.forte-1': 'Forte',
    'qpu.forte-enterprise-1': 'Forte Enterprise',
    'qpu.forte-enterprise-2': 'Forte Enterprise 2',
    'qpu.forte-enterprise-3': 'Forte Enterprise 3',
    'qpu.aria-1': 'Aria 1',
    'qpu.aria-2': 'Aria 2',
    harmony: 'Harmony',
};

/** Human-friendly QPU name; unknown slugs pass through unchanged. */
export const getFriendlyTargetName = (qpuSlug: string): string =>
    TARGET_TRANSLATION[qpuSlug] ?? qpuSlug;

const NOISE_MODELS_MAP: Record<string, string> = {
    harmony: 'Harmony noise model',
    'aria-1': 'Aria 1 noise model',
    'aria-2': 'Aria 2 noise model',
    baritone: 'Baritone noise model',
    forte: 'Forte noise model',
    'forte-1': 'Forte-1 noise model',
};

/** Display name for a job row's noise model ('' when absent or unknown). */
export const getNoiseModelName = (noise?: { model?: string }): string =>
    (noise?.model && NOISE_MODELS_MAP[noise.model]) || '';
